import { render, staticRenderFns } from "./Banners_new.vue?vue&type=template&id=5b637984&"
import script from "./Banners_new.vue?vue&type=script&lang=js&"
export * from "./Banners_new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports